import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=438c572d&scoped=true"
import script from "./Commission.vue?vue&type=script&lang=js"
export * from "./Commission.vue?vue&type=script&lang=js"
import style0 from "./Commission.vue?vue&type=style&index=0&id=438c572d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438c572d",
  null
  
)

export default component.exports